import { render } from "./NewComment.vue?vue&type=template&id=2cc7aeae&scoped=true"
import script from "./NewComment.vue?vue&type=script&lang=js"
export * from "./NewComment.vue?vue&type=script&lang=js"

import "./NewComment.vue?vue&type=style&index=0&id=2cc7aeae&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc7aeae"]])

export default __exports__